import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Programmes from "@/pages/public/Programmes";
import ProgrammeDetail from "@/pages/public/ProgrammeDetail";
import Impact from "@/pages/public/Impact";
import Donate from "@/pages/public/Donate";
import CSR from "@/pages/public/CSR";
import Gallery from "@/pages/public/Gallery";
import Media from "@/pages/public/Media";
import Article from "@/pages/public/Article";
import Contact from "@/pages/public/Contact";
import Transparency from "@/pages/public/Transparency";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import AdminProgrammes from "@/pages/admin/AdminProgrammes";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminImpact from "@/pages/admin/AdminImpact";
import AdminDocuments from "@/pages/admin/AdminDocuments";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminContent from "@/pages/admin/AdminContent";

function RequireAdmin({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="p-8 text-slate-500">Loading…</div>;
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <Routes>
                        {/* Public */}
                        <Route element={<PublicLayout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/programmes" element={<Programmes />} />
                            <Route path="/programmes/:slug" element={<ProgrammeDetail />} />
                            <Route path="/impact" element={<Impact />} />
                            <Route path="/donate" element={<Donate />} />
                            <Route path="/csr" element={<CSR />} />
                            <Route path="/gallery" element={<Gallery />} />
                            <Route path="/media" element={<Media />} />
                            <Route path="/media/:slug" element={<Article />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/transparency" element={<Transparency />} />
                        </Route>

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route
                            path="/admin"
                            element={
                                <RequireAdmin>
                                    <AdminLayout />
                                </RequireAdmin>
                            }
                        >
                            <Route index element={<Overview />} />
                            <Route path="content" element={<AdminContent />} />
                            <Route path="programmes" element={<AdminProgrammes />} />
                            <Route path="media" element={<AdminMedia />} />
                            <Route path="gallery" element={<AdminGallery />} />
                            <Route path="impact" element={<AdminImpact />} />
                            <Route path="documents" element={<AdminDocuments />} />
                            <Route path="team" element={<AdminTeam />} />
                            <Route path="enquiries" element={<AdminEnquiries />} />
                            <Route path="settings" element={<AdminSettings />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
